import * as React from 'react';

import FirestoreCollection, { CollectionState } from './FirestoreCollection';

interface FetchMoreCollectionState extends CollectionState {
  hasMore: boolean;
  fetchMore: (limit: number) => void;
}

type RenderFunc = (args: FetchMoreCollectionState) => React.ReactNode;

type FetchMoreProps = {
  path: string;
  sort?: string;
  limit?: number;
  filter?: [string, firebase.firestore.WhereFilterOp, any][];
  children?: RenderFunc;
  render?: RenderFunc;
};

const FirestoreFetchMoreCollection = ({ limit: initialLimit, render, children, ...propsRest }: FetchMoreProps) => {
  const [limit, setLimit] = React.useState(initialLimit);
  const fetchMore = (more: number) => {
    setLimit((limit || 0) + more);
  };

  const renderFunc = render || children;
  if (typeof renderFunc !== 'function') {
    return null;
  }

  return (
    <FirestoreCollection
      {...propsRest}
      limit={limit}
      render={({ isLoading, data, snapshot, error }) => {
        let hasMore = false;
        if (snapshot) {
          const { size } = snapshot;
          hasMore = size >= limit;
        }
        return renderFunc({
          isLoading,
          data,
          snapshot,
          error,
          fetchMore,
          hasMore,
        });
      }}
    />
  );
};

export default FirestoreFetchMoreCollection;
